/* =====================================================================
   GARVIN · NAVEGACIÓN MÓVIL (< 750 px) — Fase 3
   Menú hamburguesa propio. En móvil, el toque en la hamburguesa del header
   abre este panel en vez del drawer de Wonder. En tablet/escritorio no se
   toca nada. Todo por delegación en document: sobrevive al refresco del
   header tras añadir al carrito y a la recarga de la sección en el editor.
   ===================================================================== */
(function () {
  if (window.garvinMobileNav) return;
  window.garvinMobileNav = true;

  var mq = window.matchMedia('(max-width: 749.98px)');
  var docEl = document.documentElement;
  var SPEED = 280;
  var TRIGGER = '.wt-header__menu-trigger';
  var stack = [];
  var lastTrigger = null;
  var resetTimer = null;
  var animTimer = null;
  var keyboard = false; /* el anillo de foco solo se ve si se navega con teclado */

  function getMenu() {
    return document.querySelector('[data-garvin-menu]');
  }

  function isOpen(menu) {
    return !!menu && menu.classList.contains('is-open');
  }

  function setTriggers(open) {
    document.querySelectorAll(TRIGGER).forEach(function (t) {
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function currentScreen(menu) {
    return menu.querySelector('[data-gm-screen="' + stack[stack.length - 1] + '"]');
  }

  function focusFirst(menu) {
    var screen = currentScreen(menu);
    if (!screen) return;
    menu.classList.toggle('is-kbd', keyboard);
    var target = keyboard ? (screen.querySelector('[data-gm-back]') || screen.querySelector('[data-gm-close]')) : screen;
    if (target) target.focus({ preventScroll: true });
  }

  /* Clase temporal para animar el desplazamiento de la página solo al abrir/cerrar */
  function animate() {
    clearTimeout(animTimer);
    docEl.classList.add('garvin-menu-anim');
    animTimer = setTimeout(function () { docEl.classList.remove('garvin-menu-anim'); }, SPEED + 80);
  }

  function render(menu) {
    var current = stack[stack.length - 1];
    menu.querySelectorAll('[data-gm-screen]').forEach(function (s) {
      var id = s.getAttribute('data-gm-screen');
      var isCurrent = id === current;
      s.classList.toggle('is-current', isCurrent);
      s.classList.toggle('is-behind', !isCurrent && stack.indexOf(id) > -1);
      s.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
    });
  }

  function open(menu, trigger) {
    clearTimeout(resetTimer);
    lastTrigger = trigger || null;
    stack = ['root'];
    render(menu);
    menu.querySelectorAll('[data-gm-screen] .garvin-menu__body').forEach(function (b) { b.scrollTop = 0; });
    animate();
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    docEl.classList.add('garvin-menu-open');
    setTriggers(true);
    setTimeout(function () { focusFirst(menu); }, 30);
  }

  function close(menu, restoreFocus) {
    if (!isOpen(menu)) return;
    animate();
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    docEl.classList.remove('garvin-menu-open');
    setTriggers(false);
    /* Vuelve al primer nivel cuando el panel ya no se ve */
    resetTimer = setTimeout(function () {
      stack = ['root'];
      render(menu);
    }, SPEED);
    if (restoreFocus !== false && lastTrigger && document.body.contains(lastTrigger)) {
      lastTrigger.focus({ preventScroll: true });
    }
    lastTrigger = null;
  }

  function go(menu, id) {
    if (!menu.querySelector('[data-gm-screen="' + id + '"]')) return;
    stack.push(id);
    render(menu);
    var body = currentScreen(menu).querySelector('.garvin-menu__body');
    if (body) body.scrollTop = 0;
    setTimeout(function () { focusFirst(menu); }, 30);
  }

  function back(menu) {
    if (stack.length > 1) stack.pop();
    render(menu);
    setTimeout(function () { focusFirst(menu); }, 30);
  }

  /* 1. Hamburguesa: en móvil se intercepta antes que el drawer de Wonder
        (fase de captura en document = llega antes que el listener del botón) */
  document.addEventListener('click', function (e) {
    if (!mq.matches || !e.target.closest) return;
    var trigger = e.target.closest(TRIGGER);
    if (!trigger) return;
    var menu = getMenu();
    if (!menu) return; /* sin menú asignado: sigue funcionando el de Wonder */
    e.preventDefault();
    e.stopPropagation();
    if (isOpen(menu)) close(menu);
    else open(menu, trigger);
  }, true);

  /* 2. Acciones dentro del panel */
  document.addEventListener('click', function (e) {
    var menu = getMenu();
    if (!isOpen(menu) || !e.target.closest) return;
    var el = e.target.closest('[data-gm-close], [data-gm-open], [data-gm-back], [data-gm-lang], a[href]');
    if (!el || !menu.contains(el)) return;

    if (el.hasAttribute('data-gm-close')) {
      close(menu);
    } else if (el.hasAttribute('data-gm-open')) {
      e.preventDefault(); /* sin JS, el enlace lleva a la colección */
      go(menu, el.getAttribute('data-gm-open'));
    } else if (el.hasAttribute('data-gm-back')) {
      back(menu);
    } else if (el.hasAttribute('data-gm-lang')) {
      /* El drawer de idioma del tema ya se ha abierto con su propio listener */
      close(menu, false);
    } else {
      /* Enlace: se cierra para que al volver atrás el panel no siga abierto */
      close(menu, false);
    }
  });

  /* 2b. Deslizar hacia la izquierda (sobre el panel o la franja) cierra el menú.
         Solo cuenta un gesto claramente horizontal: el scroll vertical del menú
         no se ve afectado. */
  var swipe = null;
  document.addEventListener('touchstart', function (e) {
    var menu = getMenu();
    swipe = null;
    if (!isOpen(menu) || !menu.contains(e.target) || e.touches.length !== 1) return;
    swipe = { x: e.touches[0].clientX, y: e.touches[0].clientY };
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!swipe) return;
    var t = e.changedTouches[0];
    var dx = t.clientX - swipe.x;
    var dy = t.clientY - swipe.y;
    swipe = null;
    if (dx < -60 && Math.abs(dx) > Math.abs(dy) * 1.5) close(getMenu(), false);
  }, { passive: true });
  document.addEventListener('touchcancel', function () { swipe = null; }, { passive: true });

  /* Modo de entrada: teclado (anillo de foco visible) o táctil/ratón */
  document.addEventListener('pointerdown', function () { keyboard = false; }, true);

  /* 3. Teclado: Esc cierra; Tab no sale del nivel visible */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') keyboard = true;
    var menu = getMenu();
    if (!isOpen(menu)) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      close(menu);
      return;
    }
    if (e.key !== 'Tab') return;
    menu.classList.add('is-kbd');
    var screen = currentScreen(menu);
    if (!screen) return;
    var items = Array.prototype.filter.call(
      screen.querySelectorAll('a[href], button:not([disabled])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !screen.contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !screen.contains(document.activeElement))) {
      e.preventDefault();
      first.focus();
    }
  });

  /* 3b. Teclado del móvil: al escribir en un campo se oculta la barra inferior
         (y WhatsApp) para que no quede encima del teclado ni del campo.
         Clase en <html>: garvin-kbd-open. No cuenta casillas, botones, etc. */
  var NO_KEYBOARD = /^(checkbox|radio|button|submit|reset|range|color|file|image|hidden)$/;
  function isTyping(el) {
    if (!el) return false;
    if (el.isContentEditable) return true;
    var tag = el.tagName;
    if (tag === 'TEXTAREA' || tag === 'SELECT') return true;
    if (tag === 'INPUT') return !NO_KEYBOARD.test((el.getAttribute('type') || 'text').toLowerCase());
    return false;
  }
  document.addEventListener('focusin', function (e) {
    if (mq.matches && isTyping(e.target)) docEl.classList.add('garvin-kbd-open');
  });
  document.addEventListener('focusout', function () {
    setTimeout(function () {
      if (!isTyping(document.activeElement)) docEl.classList.remove('garvin-kbd-open');
    }, 80);
  });

  /* 4. Si se pasa a tablet/escritorio con el panel abierto, se cierra */
  function onBreakpoint() {
    if (!mq.matches) close(getMenu(), false);
  }
  if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
  else if (mq.addListener) mq.addListener(onBreakpoint);

  /* 6. Barra inferior (19/10, estilo Glovo)
        - Tocar una pestaña: la píldora se desliza hasta ella y se navega.
        - Arrastrar el dedo por la barra: la píldora sigue al dedo; al soltar
          se abre la pestaña que queda debajo.
        - Tocar la pestaña de la página en la que ya estás: sube arriba.
        Todo por delegación: sobrevive a la recarga de la sección en el editor. */
  var DRAG_START = 8; /* px de movimiento horizontal para empezar a arrastrar */
  var drag = null;
  var suppressClick = false;
  var suppressTimer = null;

  function dockItems(dock) {
    return Array.prototype.slice.call(dock.querySelectorAll('.garvin-dock__item'));
  }

  function setDockActive(dock, idx) {
    var prev = parseInt(dock.getAttribute('data-active'), 10);
    if (prev === -1 && idx > -1) {
      /* Sin pestaña previa: la píldora aparece en su sitio, sin viajar */
      dock.classList.add('no-anim');
      dock.style.setProperty('--gmn-i', idx);
      void dock.offsetWidth;
      dock.classList.remove('no-anim');
    }
    dockItems(dock).forEach(function (it, i) {
      it.classList.toggle('is-active', i === idx);
      it.classList.remove('is-hover');
    });
    dock.style.setProperty('--gmn-i', idx);
    dock.setAttribute('data-active', String(idx));
  }

  function isSamePage(link) {
    return link.origin === location.origin && link.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '');
  }

  function dragPosition(d, clientX) {
    var slot = (d.rect.width - 8) / 4;
    var x = clientX - d.rect.left - 4 - slot / 2;
    x = Math.max(0, Math.min(x, slot * 3));
    return { x: x, idx: Math.round(x / slot) };
  }

  document.addEventListener('pointerdown', function (e) {
    drag = null;
    if (!mq.matches || !e.isPrimary || e.button > 0 || !e.target.closest) return;
    var dock = e.target.closest('[data-garvin-dock]');
    if (!dock) return;
    drag = { dock: dock, id: e.pointerId, x0: e.clientX, y0: e.clientY, moved: false, idx: -1, rect: dock.getBoundingClientRect() };
  });

  document.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    if (!drag.moved) {
      if (Math.abs(e.clientX - drag.x0) < DRAG_START) return;
      drag.moved = true;
      drag.dock.classList.add('is-dragging');
      try { drag.dock.setPointerCapture(drag.id); } catch (err) {}
    }
    var pos = dragPosition(drag, e.clientX);
    drag.dock.style.setProperty('--gmn-x', pos.x + 'px');
    if (pos.idx !== drag.idx) {
      drag.idx = pos.idx;
      dockItems(drag.dock).forEach(function (it, i) { it.classList.toggle('is-hover', i === pos.idx); });
    }
  });

  function endDrag(e, cancelled) {
    if (!drag || e.pointerId !== drag.id) return;
    var d = drag;
    drag = null;
    if (!d.moved) return; /* toque normal: lo gestiona el click */
    d.dock.classList.remove('is-dragging');
    clearTimeout(suppressTimer);
    suppressClick = true;
    suppressTimer = setTimeout(function () { suppressClick = false; }, 400);

    var items = dockItems(d.dock);
    if (cancelled || d.idx < 0 || !items[d.idx]) {
      setDockActive(d.dock, parseInt(d.dock.getAttribute('data-page'), 10));
      return;
    }
    var link = items[d.idx];
    setDockActive(d.dock, d.idx);
    if (isSamePage(link)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    /* Pequeña pausa para que se vea la píldora encajando en su sitio */
    setTimeout(function () { window.location.href = link.href; }, 90);
  }

  /* Que el navegador no intente «arrastrar el enlace» (cancelaría el gesto) */
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('[data-garvin-dock]')) e.preventDefault();
  });

  document.addEventListener('pointerup', function (e) { endDrag(e, false); });
  document.addEventListener('pointercancel', function (e) { endDrag(e, true); });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var link = e.target.closest('.garvin-dock__item');
    if (!link) return;
    var dock = link.closest('[data-garvin-dock]');
    if (!dock) return;
    if (suppressClick) {
      /* El arrastre ya ha decidido adónde ir */
      e.preventDefault();
      suppressClick = false;
      return;
    }
    if (!mq.matches || e.metaKey || e.ctrlKey || e.shiftKey) return;
    setDockActive(dock, dockItems(dock).indexOf(link));
    if (isSamePage(link)) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, true);

  /* 5. Volver con el botón atrás del navegador desde caché: panel cerrado y
        píldora de vuelta en la pestaña de esa página */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    close(getMenu(), false);
    document.querySelectorAll('[data-garvin-dock]').forEach(function (dock) {
      dock.classList.remove('is-dragging');
      dock.classList.add('no-anim');
      setDockActive(dock, parseInt(dock.getAttribute('data-page'), 10));
      void dock.offsetWidth;
      dock.classList.remove('no-anim');
    });
  });

  /* 7. Pop-up de newsletter (Klaviyo) en móvil (20/10)
        La hoja se puede arrastrar hacia abajo para cerrarla, como una hoja
        nativa. Se cierra pulsando la X de Klaviyo, así Klaviyo registra el
        cierre igual que con la cruz (no vuelve a salir antes de tiempo).
        No empieza el arrastre sobre campos, casilla, botón ni enlaces. */
  var KL_DIALOG = 'div[role="dialog"][aria-label="POPUP Form"]';
  var KL_NO_DRAG = 'input, textarea, select, button, a, label, .klaviyo-close-form';
  var KL_DIM = 0.45; /* opacidad del velo (igual que garvin-klaviyo.css) */
  var klReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var kl = null;

  function klStyle(el, prop, value) {
    if (value === null) el.style.removeProperty(prop);
    else el.style.setProperty(prop, value, 'important'); /* Klaviyo y garvin-klaviyo.css usan !important */
  }

  function klAnim(ms) {
    return klReduce.matches ? 'none' : 'transform ' + ms + 'ms cubic-bezier(.2,.8,.2,1), background-color ' + ms + 'ms ease';
  }

  function klRestore(d) {
    klStyle(d.sheet, 'transition', klAnim(240));
    klStyle(d.dialog, 'transition', klAnim(240));
    klStyle(d.sheet, 'transform', 'translateY(0)');
    klStyle(d.dialog, 'background-color', 'rgba(21, 21, 21, ' + KL_DIM + ')');
    setTimeout(function () {
      klStyle(d.sheet, 'transition', null);
      klStyle(d.sheet, 'transform', null);
      klStyle(d.dialog, 'transition', null);
      klStyle(d.dialog, 'background-color', null);
    }, 260);
  }

  function klDismiss(d) {
    var ms = 220;
    klStyle(d.sheet, 'transition', klAnim(ms));
    klStyle(d.dialog, 'transition', klAnim(ms));
    klStyle(d.sheet, 'transform', 'translateY(' + (d.h + 40) + 'px)');
    klStyle(d.dialog, 'background-color', 'rgba(21, 21, 21, 0)');
    setTimeout(function () {
      var btn = d.dialog.querySelector('.klaviyo-close-form');
      if (btn) btn.click();
      else d.dialog.style.display = 'none';
    }, klReduce.matches ? 0 : ms);
  }

  document.addEventListener('touchstart', function (e) {
    kl = null;
    if (!mq.matches || e.touches.length !== 1 || !e.target.closest) return;
    var dialog = e.target.closest(KL_DIALOG);
    if (!dialog) return;
    var sheet = dialog.firstElementChild;
    if (!sheet || !sheet.contains(e.target) || e.target.closest(KL_NO_DRAG)) return;
    /* Si la hoja tiene scroll propio y no está arriba, el gesto es scroll */
    if (dialog.scrollTop > 0 || sheet.scrollTop > 0) return;
    var t = e.touches[0];
    kl = { dialog: dialog, sheet: sheet, x0: t.clientX, y0: t.clientY, dy: 0, active: false,
      h: sheet.getBoundingClientRect().height, lastY: t.clientY, lastT: e.timeStamp, v: 0 };
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!kl) return;
    var t = e.touches[0];
    var dx = t.clientX - kl.x0;
    var dy = t.clientY - kl.y0;
    if (!kl.active) {
      if (dy > 6 && dy > Math.abs(dx)) {
        kl.active = true;
        klStyle(kl.sheet, 'transition', 'none');
        klStyle(kl.dialog, 'transition', 'none');
      } else if (Math.abs(dx) > 6 || dy < -6) {
        kl = null;
      }
      return;
    }
    e.preventDefault(); /* sin scroll ni «tirar para recargar» de fondo */
    kl.dy = Math.max(0, dy);
    var dt = e.timeStamp - kl.lastT;
    if (dt > 0) kl.v = (t.clientY - kl.lastY) / dt;
    kl.lastY = t.clientY;
    kl.lastT = e.timeStamp;
    klStyle(kl.sheet, 'transform', 'translateY(' + kl.dy + 'px)');
    var a = KL_DIM * (1 - Math.min(1, kl.dy / kl.h));
    klStyle(kl.dialog, 'background-color', 'rgba(21, 21, 21, ' + a.toFixed(3) + ')');
  }, { passive: false });

  function klEnd(cancelled) {
    var d = kl;
    kl = null;
    if (!d || !d.active) return;
    /* Se cierra al bajarla un 25 % (máx. 120 px) o con un gesto rápido */
    if (!cancelled && (d.dy > Math.min(120, d.h * 0.25) || (d.v > 0.5 && d.dy > 30))) klDismiss(d);
    else klRestore(d);
  }

  document.addEventListener('touchend', function () { klEnd(false); }, { passive: true });
  document.addEventListener('touchcancel', function () { klEnd(true); }, { passive: true });
})();
